import React, { forwardRef } from 'react';
import { useDataProvider, useRefresh, useNotify } from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';

const EnableSubUserAction = forwardRef((props: any, ref: any) => {
  const { tenantId, record } = props;

  const notify = useNotify();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();

  const handleClick = async () => {
    try {
      await dataProvider.post('enableOrDisableMember', {
        tenantId,
        memberId: record.id,
        action: record.enabled ? 'disable' : 'enable',
      });

      refresh();
    } catch (error: any) {
      notify(
        typeof error === 'string' ? error : error.message || 'ra.notification.http_error',
        'warning'
      );
    }
  };

  return (
    <MenuItem ref={ref} onClick={handleClick}>
      {record.enabled ? 'Disable' : 'Enable'}
    </MenuItem>
  );
});

export default EnableSubUserAction;
